<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :viewbox-width="26"
        :viewbox-height="24"
        color="transparent"
        :fill-color="color"
        @click="$emit('click')"
    >
        <path
            d="M2.39903 24C1.99476 24 1.59369 23.8965 1.23956 23.7013C0.0811595 23.0613 -0.341241 21.5989 0.298759 20.4405L10.6956 1.24587C10.9164 0.8448 11.2417 0.519467 11.6385 0.299733C11.9948 0.103467 12.3948 0 12.7969 0C13.022 0 13.246 0.032 13.4646 0.0949333C14.0812 0.272 14.591 0.679467 14.9004 1.24053L25.3036 20.4459C25.4966 20.7957 25.599 21.1957 25.599 21.6C25.599 22.9237 24.5228 24 23.199 24H2.39903ZM12.798 1.6C12.6625 1.6 12.5334 1.63413 12.4129 1.70027C12.2806 1.7728 12.1729 1.8816 12.0993 2.01387L1.70249 21.2085C1.59689 21.3995 1.57236 21.616 1.63209 21.8219C1.69183 22.0277 1.82623 22.1973 2.01289 22.3008C2.13129 22.3659 2.26463 22.4011 2.39903 22.4011H23.199C23.6406 22.4011 23.999 22.0416 23.999 21.6011C23.999 21.4667 23.9649 21.3333 23.8988 21.2149L13.4966 2.0096C13.3953 1.82613 13.2257 1.69067 13.0209 1.632C12.9473 1.61067 12.8726 1.6 12.798 1.6Z"
        />
        <path
            d="M12.7986 20.0005C12.7517 20.0005 12.7048 19.9962 12.66 19.9888C12.1128 19.9248 11.6754 19.4874 11.6114 18.9402C11.6029 18.8944 11.5986 18.8474 11.5986 18.8005C11.5986 18.7536 11.6029 18.7066 11.6114 18.6608C11.6754 18.1136 12.1128 17.6773 12.66 17.6133C12.7048 17.6048 12.7517 17.6016 12.7997 17.6016C12.8477 17.6016 12.8936 17.6058 12.9384 17.6133C13.4856 17.6773 13.9229 18.1146 13.9869 18.6618C13.9954 18.7066 13.9986 18.7536 13.9986 18.8016C13.9986 18.8496 13.9944 18.8954 13.9869 18.9413C13.9229 19.4885 13.4856 19.9258 12.9384 19.9898C12.8925 19.9973 12.8466 20.0005 12.7986 20.0005Z"
        />
        <path
            d="M12.799 15.9992C12.3574 15.9992 11.999 15.6408 11.999 15.1992V7.99922C11.999 7.55762 12.3574 7.19922 12.799 7.19922C13.2396 7.19922 13.599 7.55762 13.599 7.99922V15.1992C13.599 15.6408 13.2406 15.9992 12.799 15.9992Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'WarningOutlinedIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>
